import React from 'react';
import { Controller } from 'react-hook-form';

const SharedControllers = ({ control, idx, field }) => {
  return (
    <>
      <Controller
        control={control}
        name={`additionalContents[${idx}].id`}
        as={<input hidden />}
        defaultValue={field.id}
      />
      <Controller
        control={control}
        name={`additionalContents[${idx}].revisionId`}
        as={<input hidden />}
        defaultValue={field.revisionId}
      />
      <Controller
        control={control}
        name={`additionalContents[${idx}].name`}
        as={<input hidden />}
        defaultValue={field.name}
      />
      <Controller
        control={control}
        name={`additionalContents[${idx}].position`}
        as={<input hidden />}
        defaultValue={field.position}
      />
    </>
  );
};

export default SharedControllers;
